<div (click)="notificationService.updateNotifications()" [tp]="notificationDropdown" tpVariation="popper"
  tpPlacement="bottom-start"
  class="hover:text-gray-600 bg-gray-100 border md:border-none hover:cursor-pointer hover:bg-gray-200 {{notificationService.notification_count() > 0?'text-black':'text-gray-600'}} rounded-lg transition-colors duration-200">
  <div tp="Notifications" class="relative flex items-center gap-2 p-2">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
    </svg>
    @if(notificationService.notification_count() > 0) {
    <div
      class="absolute -top-2 -right-2 p-[10px] h-4 w-4 flex items-center justify-center rounded-full bg-[#2e283e] text-[#F5F5F5] text-xs">
      {{ notificationService.notification_count() > 10 ? '10+' : notificationService.notification_count() }}
    </div>
    }
  </div>
</div>

<ng-template #notificationDropdown let-hide let-item="data">
  <div class="max-h-[calc(100svh-250px)] overflow-y-auto overflow-x-hidden">
    @for(notification of notificationService.notifications();track notification._id) {
    <div class="group py-3 px-1 hover:bg-gray-100 transition-colors duration-200 rounded-[8px]">
      <!-- Notification Content -->
      <div class="flex space-x-3 items-baseline">
        <!-- Unread Indicator -->
        <div
          class="flex-shrink-0 w-2 h-2 rounded-full {{notification.status === 'read'?'bg-transparent':'bg-blue-600'}}">
        </div>
        <div class="flex-1 min-w-0">
          <p class="text-sm {{notification.status !== 'read'?'text-[#2A5B8C]':'text-slate-400'}}">
            {{ notification.message }}
          </p>
          <p class="text-xs text-gray-400 mt-1">
            {{ notification.time }}
          </p>
        </div>
      </div>
    </div>
    }
  </div>

  <!-- Empty State -->
  @if(notificationService.notifications().length === 0) {
  <div class="p-4 text-center text-gray-500">
    <p>No Notifications</p>
  </div>
  }
</ng-template>
